export default __webpack_public_path__ + "code.png";